<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
    <path
      d="M36.97,6.856,31.144,1.03a3.511,3.511,0,0,0-4.968,0L3.3,23.9a1.253,1.253,0,0,0-.331.587L.037,36.447a1.254,1.254,0,0,0,1.516,1.516l11.958-2.936A1.253,1.253,0,0,0,14.1,34.7L36.97,11.824A3.511,3.511,0,0,0,36.97,6.856Zm-34,28.178.12-.487.367.367ZM6.3,34.216,3.784,31.7l1.094-4.454,5.875,5.875Zm6.913-2.18L5.964,24.788,24.682,6.069l7.249,7.249ZM35.2,10.052,33.75,11.5,26.5,4.25,27.949,2.8a1,1,0,0,1,1.422,0L35.2,8.629A1,1,0,0,1,35.2,10.052Z"
      :fill="fill"
    />
  </svg>
</template>

<script setup lang="ts">
interface EditIconProps {
  fill?: string;
}

withDefaults(defineProps<EditIconProps>(), {
  fill: '#707070',
});
</script>
